// extracted by mini-css-extract-plugin
export default {"homepageSideNav":"_1S8C-uMyHqTiepORimhuoB"};